"use client"

import { ChakraProvider, ColorModeScript, withDefaultColorScheme, extendTheme } from "@chakra-ui/react"
import spearTheme from "../theme"

// `brand` is a full 50–900 scale, so it can back Chakra's colorScheme system
// for the components that use it (Checkbox, Switch, Progress, Spinner…).
const theme = extendTheme(spearTheme, withDefaultColorScheme({ colorScheme: "brand" }))

const ChakraWrapper = ({ children }) => (
  <>
    <ColorModeScript initialColorMode={theme.config.initialColorMode} />
    {/* The previous wrapper held the whole app at opacity 0 for 100ms on every
        boot "for smooth transitions". It read as a flash of blank page. */}
    <ChakraProvider theme={theme}>{children}</ChakraProvider>
  </>
)

export default ChakraWrapper
